import { ENV } from 'config';
import React, { useEffect, useState }  from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { getVersion } from '../../api';
import Body03 from '../../Components/designSystem/components/typography/Body03';
import { FOOTER_HEIGHT } from '../constants';

const SIDEBAR_WIDTH = 320;

interface FooterProps {
    className?: string;
    withSidebar?: boolean;
}

const Footer = ({ className, withSidebar }: FooterProps) => {
    const { t } = useTranslation('common');
    const [ version, setVersion ] = useState('-');

    useEffect(() => {
        const updateVersion = async () => {
            const fetchedVersion = await getVersion();
            setVersion(fetchedVersion);
        };

        updateVersion();
    }, []);

    return (
        <FooterContainer className={ className }
            withSidebar={ withSidebar }
        >
            <FooterLink onClick={ () => {
                window._iub.cs.api.openPreferences();
            } }>Cookies</FooterLink>

            • 

            <FooterLink as="a"
                href={ ENV.PRIVACY_LINK }
                target="_blank"
            >{ t('privacy') }</FooterLink>

            • 

            <Link
                href="http://globus.ai"
                target="_blank"
            >
                &copy; { new Date().getFullYear() } Globus.ai
            </Link>

            <Version>
                { version }
            </Version>

        </FooterContainer>
    );
};

export default React.memo(Footer);

const FooterContainer = styled.div<{ withSidebar?: boolean }>`
    align-items: center;
    background-color: transparent;
    color: ${ ({ theme }) => theme.color.grey.grey_50 };
    display: flex;
    gap: ${ ({ theme }) => theme.size.size_10 };
    align-items: center;
    font-size: 12px;
    line-height: 20px;
    height: ${ FOOTER_HEIGHT }px;
    justify-content: center;
    position: relative;
    width: 100%;
    color: ${ ({ color, theme }) => (color ? color : theme.semanticColor.textSecondary) };
    white-space: nowrap;

    @media ${ ({ theme }) => theme.breakpoints.mediaQueries.isDesktop } {
        width: ${ ({ withSidebar }) => (withSidebar ? `calc(100% - ${ SIDEBAR_WIDTH }px)` : '100%') }
    }

    @media ${ ({ theme }) => theme.breakpoints.mediaQueries.isMobile } {
        justify-content: flex-start;
        padding: ${ ({ theme }) => `${ theme.size.size_20 } ${ theme.size.size_30 }` };
    }
`;

const Link = styled.a`
    display: flex;
    margin-left: 2px;
    color: inherit;

    &:hover {
        color: ${ ({ theme }) => theme.semanticColor.textPrimary };
    }
`;

const FooterLink = styled(Body03)`
    cursor: pointer;
    color: inherit;

    &:hover, &:active {
        color: ${ ({ theme }) => theme.semanticColor.textPrimary };
    }
`;

const Version = styled.span`
    color: transparent;
    position: absolute;
    right: 20px;

    &::selection {
        color: ${ ({ theme }) => theme.semanticColor.textPrimary };
    }

    @media ${ ({ theme }) => theme.breakpoints.mediaQueries.isMobile } {
        display: none;
    }
`;
